import React, { useEffect, useState } from "react"
import { Navbar, NavbarBrand, Nav, NavItem, NavLink, Input, Dropdown, DropdownToggle, DropdownMenu, DropdownItem, Button, InputGroup } from "reactstrap"
import { FaSearch } from "react-icons/fa"
import styles from "./SellerHeader.module.scss"
import MaelanoIcon from "../../../../assets/icons/MaelanoIcon.png"
import MaelanoTextIcon from "../../../../assets/icons/MaelanoTextIcon.svg"
import { BsChatSquareText } from "react-icons/bs"
import { GoBell } from "react-icons/go"
import { PiUserSwitch } from "react-icons/pi"
import { liteClient as algoliasearch } from "algoliasearch/lite"
import { Highlight, InstantSearch, RefinementList, useHits, useSearchBox } from "react-instantsearch"

const searchClient = algoliasearch("RVRWEJVPCS", "c6b8d20a49b125cae5488e16e095fa72")

const CustomSearchBox = ({ query, setQuery }) => {
  const { refine } = useSearchBox()

  const handleSearch = (event) => {
    const value = event.target.value
    setQuery(value)
    refine(value)
  }

  return (
    <InputGroup className={styles.inputGrp}>
      <Input type="text" placeholder="Search" value={query} onChange={handleSearch} className={styles.searchField} />
      <Button type="button" color="warning" className={styles.searchBtn}>
        <FaSearch />
      </Button>
    </InputGroup>
  )
}


const CustomHits = ({ query }) => {
  const { hits } = useHits()

  if (!query) return null

  return (
    <ul className={styles.resultsList}>
      {hits?.length > 0 ? (
        hits.map((hit) => (
          <li key={hit.objectID} className={styles.resultItem}>
            <Highlight attribute="category" hit={hit} tagName="mark" />
          </li>
        ))
      ) : (
        <li className={styles.noResults}>No results found</li>
      )}
    </ul>
  )
}

const SellerHeader = () => {
  const [dropdownOpen, setDropdownOpen] = useState(false)

  const toggleDropdown = () => setDropdownOpen((prevState) => !prevState)

  const [query, setQuery] = useState("")

  return (
    <header className={styles.sellerHeader}>
      <Navbar expand="md" className={`fixed-top ${styles.navbar}`}>
        <div className={styles.logoSearchHeaderContainer}>
          {/* Logo */}
          <NavbarBrand href="/dashboard" className={styles.logoIcons}>
            <img src={MaelanoIcon} alt="Logo" className="bg-white p-2 px-1 rounded-3" />
            <img src={MaelanoTextIcon} alt="Maelano Logo" className={styles["maelano-text"]} />
          </NavbarBrand>

          {/* Search Bar */}
          <div className={styles.searchContainer}>
            <InstantSearch searchClient={searchClient} indexName="products">
              <CustomSearchBox query={query} setQuery={setQuery} />
              <CustomHits query={query} />
            </InstantSearch>
          </div>
        </div>

        {/* Right Side Icons and Dropdown */}
        <Nav className={styles.iconsDropdownNav}>
          <NavItem>
            <NavLink href="#" className={styles.iconLink}>
              <BsChatSquareText size={24} />
            </NavLink>
          </NavItem>
          <NavItem>
            <NavLink href="#" className={styles.iconLink}>
              <GoBell size={24} />
            </NavLink>
          </NavItem>
          <NavItem>
            <NavLink href="#" className={styles.iconLink}>
              <img src={require("../../../../assets/images/SellerPortalImages/SellerHeader/UserImg.png")} alt="User Avatar" className={styles.userAvatar} />
            </NavLink>
          </NavItem>
          <NavItem>
            <Dropdown isOpen={dropdownOpen} toggle={toggleDropdown}>
              <DropdownToggle caret className={styles.dropdownToggleBtn}>
                <span className="d-md-block d-none">Switch to</span>

                <span className="d-md-none d-block">
                  <PiUserSwitch size={24} />
                </span>
              </DropdownToggle>
              <DropdownMenu>
                <DropdownItem className={styles["dropdown-item"]}>User</DropdownItem>
                <DropdownItem className={styles["dropdown-item"]}>Affiliate</DropdownItem>
                <DropdownItem className={styles["dropdown-item"]}>Wholesaler</DropdownItem>
                <DropdownItem className={styles["dropdown-item"]}>Retailer</DropdownItem>
                <DropdownItem className={styles["dropdown-item"]}>Super Admin</DropdownItem>
              </DropdownMenu>
            </Dropdown>
          </NavItem>
        </Nav>
      </Navbar>
    </header>
  )
}

export default SellerHeader
